import { CancelableRequest } from '@fino/ng1-request';
import { DataResponse } from '@fino/ng1-response/lib';

export class StatusService extends CancelableRequest {
  constructor($http, $q, appConfig, configService) {
    'ngInject';
    super({ $http, $q, appConfig, configService });
  }

  get api() {
    return this.appConfig.get().api.path;
  }

  get environment() {
    if (this.configService.isDevelopment()) {
      return '.dev';
    }

    if (this.configService.isTesting()) {
      return '.test';
    }

    return '';
  }

  getStatus(id, birthDate) {
    return this.$http({
      method: 'POST',
      data: {
        birthDate,
      },
      error: {
        silent: true,
      },
      url: `${this.api}/statuses/${id}`,
    }).then(DataResponse.transform('data'));
  }

  markStatusAsCompleted(id, birthDate) {
    return this.$http({
      method: 'POST',
      data: {
        birthDate,
      },
      error: {
        silent: true,
      },
      url: `${this.api}/statuses/${id}/confirm`,
    }).then(DataResponse.transform('data'));
  }
}



// WEBPACK FOOTER //
// ./src/app/components/status/status.service.js